"use strict";

import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AccountActions, SessionActions, AlertActions } from '../../../actions';
class AddNewAnswer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answer: '',
    };
    this._handleSubmit = this._handleSubmit.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired
  };
  render() {
    return (
      <Modal show={this.props.open} >
        <Modal.Header closeButton>
          <Modal.Title>Add Answer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <textarea rows="5" className='form-control'
                        value={ this.state.answer }
                        placeholder="Enter answer"
                        onChange={ (e)=>{
                          this.setState({answer:e.target.value});
                        }}/>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button title={this.state.answer.length<9 ? 'Answer must be minimum of 8 characters':' Submit'} bsStyle="primary" disabled={this.state.answer.length<9} onClick={(e) => {
              this._handleSubmit(e);
            }} >Submit</Button>
            <Button className="m-l-5p" type="submit" bsStyle="default" onClick={() => {
              this.setState({answer:''});
              this.props.onClose();
            }}>Cancel</Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  };

  _handleSubmit(e) {
    e.preventDefault();
    this.props._handleSubmit(this.state.answer);
    this.setState({answer:''});
  };
}

export default AddNewAnswer;
